import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-ios-certificate-generator-info-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './ios-certificate-generator-info-section.component.html',
  styleUrl: './ios-certificate-generator-info-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IosCertificateGeneratorInfoSectionComponent {
  protected readonly features = [
    {
      icon: '@tui.globe',
      title: 'Browser-Based',
      description:
        'Generate your CSR and convert certificates directly in your browser. No Keychain Access or macOS required.',
    },
    {
      icon: '@tui.shield-check',
      title: 'Privacy-First',
      description:
        'Your private key never leaves your device. Everything runs locally using the Web Crypto API.',
    },
    {
      icon: '@tui.list',
      title: 'Two-Step Process',
      description:
        'Generate a CSR, upload it to Apple Developer Portal, then convert the returned .cer to a .p12 bundle.',
    },
  ];
}
